import { ActionTree, ActionContext } from 'vuex'
import pick from 'lodash/pick'
import { eventsList } from '@/helpers/eventsList'
import { IRootState, IEventsState } from '@/@types'
import { postMixpanelEvent } from '@/models/events'
import { actionErrorHandling } from '@/helpers/errorHandling'

const actions: ActionTree<IEventsState, IRootState> = {
  sendMixpanelEvent: async (
    context: ActionContext<IEventsState, IRootState>,
    payload: { event_name: string; properties: object }
  ) => {
    if (!process.env.VUE_APP_MIXPANEL_ENABLED) return
    try {
      const sentPayload = {
        user_id:
          context.rootState.auth.userProfile.user_id || context.rootState.auth.userProfile.id,
        event_name: payload.event_name,
        properties: {
          source: 'checkout.ine.com',
          ...pick(payload.properties, eventsList[payload.event_name]),
          email: context.rootState.auth.userProfile.email,
        },
      }
      await postMixpanelEvent(sentPayload)
    } catch (error) {
      actionErrorHandling(context, error)
    }
  },
  sendGAEvent: (context: ActionContext<IEventsState, IRootState>, payload) => {
    try {
      const initEcommerce = {
        ecommerce: null,
      }
      window.dataLayer.push(initEcommerce)
      window.dataLayer.push(payload)
    } catch (error) {
      actionErrorHandling(context, error)
    }
  },
  updateDataLayer: (context: ActionContext<IEventsState, IRootState>, payload) => {
    context.commit('UPDATE_DATA_LAYER', payload)
  },
}

export default actions
